import { RouteProp, useNavigation, useRoute } from '@react-navigation/native';
import React from 'react';

import {
  SignedInNavigationScreenNavigationProp,
  SignedInRootStackParamList,
} from '../../../../../routes/types';
import {
  fundsFiltersQuery,
  fundsAssetsQuery,
} from '../../../../../store/customerAssetDetail/selector';
import { FeatureToggle, useUnleashFlags } from '../../../../../utils/useUnleashFlags';
import { DynamicAssetTableProps } from '../../DynamicAsset';
import { DynamicProductTable } from '../_dynamic';

import { FundsSecondaryInfo } from './components/SecondaryInfo';
import { tableHead } from './constants';
import ProductItem from './item';

export const FundsTable: React.FC<DynamicAssetTableProps> = (props) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const { params } = useRoute<RouteProp<SignedInRootStackParamList, 'CustomersAssetsDetails'>>();
  const { b2bRedemptionSolicitationEnabled } = useUnleashFlags(
    FeatureToggle.RedemptionSolicitationIsEnabled
  );

  const handlePressQuoteButton = (productId: number, productName: string) => {
    navigate('RedemptionSolicitation', {
      ...params,
      productId,
      productName,
      productType: 'Funds',
    });
  };

  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      productsQuery={fundsAssetsQuery}
      filtersQuery={fundsFiltersQuery}
      tableHeadItems={tableHead}
      tabletColumns={4}
      tabletSecondaryInfo={FundsSecondaryInfo}
      mobileSecondaryInfo={FundsSecondaryInfo}
      mobileColumns={2}
      mobileRows={2}
      quoteButtonInfoGetter={(item) => ({
        hasQuote: false,
        customProps: !b2bRedemptionSolicitationEnabled ? { display: 'none' } : {},
        onPress: () => handlePressQuoteButton(item.productId, item.productNameNormalized),
        isDisabled: !item.allowWithdraw,
      })}
      mobileFields={[
        { key: 'productNameNormalized', label: 'Ativo' },
        { key: 'productTypeNormalized', label: 'Tipo' },
        { key: 'positionDateNormalized', label: 'Data da posição' },
        { key: 'valueNormalized', label: 'Valor' },
        { key: 'variationNormalized', label: 'Variação', coloredField: 'variationType' },
      ]}
    />
  );
};
